<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"><a id="ch00_fm04_copyright"></a><a id="page_iv"></a><span class="small">NEW YORK UNIVERSITY PRESS</span></p>
<p class="copy2">New York and London</p>
<p class="copy2"><span class="weblink"><a class="nounder" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></span></p>
<p class="copy1a">© 2005 by New York University</p>
<p class="copy2">All rights reserved</p>
<p class="copy1">All writings by Helen Keller courtesy of the American Foundation<br/>for the Blind. Requests for permission for the use of these materials<br/>should be addressed in writing to the American Foundation for the<br/>Blind, 11 Penn Plaza, Suite 300, New York, NY 10001.</p>
<p class="copy1">All photographs courtesy of the American Foundation for the Blind,<br/>Helen Keller Archives.</p>
<p class="copy1">Book design by Charles B. Hames</p>
<p class="copy1a">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy2">Keller, Helen, 1880-1968.</p>
<p class="copy2">[Selections. 2005]</p>
<p class="copy2">Helen Keller : selected writings / edited by Kim E. Nielsen.</p>
<p class="copy2">p. cm. —(The history of disability series)</p>
<p class="copy2">“Published in conjunction with the</p>
<p class="copy2">American Foundation for the Blind.”</p>
<p class="copy2">Includes bibliographical references and index.</p>
<p class="copy2">ISBN 0-8147-5829-0 (cloth : alk. paper)</p>
<p class="copy2">1. Keller, Helen, 1880-1968.</p>
<p class="copy2">2. Blind-deaf women—United States.</p>
<p class="copy2">I. Nielsen, Kim E. II. Title. III. Series.</p>
<p class="copy2">HV1624.K4A25    2005</p>
<p class="copy2">362.4′1′092-dc22       2004028974</p>
<p class="copy1">New York University Press books are printed on acid-free paper,<br/>and their binding materials are chosen for strength and durability.</p>
<p class="copy1">Manufactured in the United States of America</p>
<p class="copy1a">c 10 9 8 7 6 5 4 3 2 1</p>
<p class="copy2">p 10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm04_copyright.vue?75f06993